import { type MentionDescription } from '@atlaskit/mention/types';
import { type Agent } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

/**
 * Maps a Rovo Agent into a MentionDescription for the @-mention typeahead.
 * `appType: 'agent'` is the platform-canonical agent discriminator.
 */
export const agentToMentionDescription = (agent: Agent): MentionDescription => ({
	id: agent.id,
	name: agent.name,
	mentionName: agent.name,
	userType: 'APP',
	appType: 'agent',
});
